import React from "react";
import { NumberInput } from "@jsq/ds/core";
import { createFieldPlaceholder, handleNumberInputWheel } from "./utils";
import type { FieldEditorProps } from "./types";

/**
 * Float Field Editor Component
 *
 * Specialized input component for float extension fields.
 * Provides number input with decimal validation and design system styling.
 */
export const FloatFieldEditor: React.FC<FieldEditorProps> = ({
  field,
  value,
  onChange,
  error,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const handleSetValue = (newValue: string) => {
    onChange(newValue);
  };

  return (
    <NumberInput
      value={value}
      onChange={handleChange}
      onSetValue={handleSetValue}
      onWheel={handleNumberInputWheel}
      placeholder={createFieldPlaceholder(field)}
      disabled={disabled}
      errorMessage={error || undefined}
      isFullWidth
      step="any"
      data-testid="float-field-editor"
    />
  );
};

export default FloatFieldEditor;
